import React, { Component } from 'react';
import * as Prevnext from './../../components/Prevnext';
const $=window.$;

class Recap_list extends Component {
	constructor(props) {
		super(props);
       this.state={
    };
	}

	componentDidMount() {
	}
	
	render() {
		let lr_lists=null;
		if(this.props.lr_lists!=null || this.props.lr_lists!=undefined){
		 lr_lists = this.props.lr_lists.map((key,index)=>{
			return <div key={`lr-key${index}`} id={`Hire${index}`} style={{display:`${index==0?'':'none'}`}}><br />
							<div className="recap-content" id={`LROOM${key['lr']}`} style={{display:''}}>
								<div className="recap-left" >
									<ul>
									{this.props.lr_lists[index].divider.map((divide,divi)=>{
										return <div key={`divider_${divi}`}>
										{this.props.lr_lists[index].componentslists[divide].map((val,ind)=>{
											return <div key={`componentslists_${ind}`}>
											<li key={`lr-li${ind}`}><div className={val['spanclass']}></div></li>															
												</div>
											})
										 }
										 <li key={`lr-li${divi}`} className="recapsep">
											<div className="lrdivider-rc">&nbsp;</div>
										  </li>
										</div>
									})
									}
									</ul>
								 </div>
										<div className="recap-right">
											<h2>{key['lr_name']}</h2>
											{key['recap']!='' ?
												<div className="recap-right-content">
													<h3>Recap</h3><span dangerouslySetInnerHTML={{ __html:key['recap']?key['recap']:''}} />
                                        		</div>
                                        		:
                                        		''
                                        	}
                                        	<div className="recap-right-content">
												<h3>Notes</h3>

											{(key['count_note']!=0)?
												<div key={`count_note_${index}`}>
                                            	{key['noteslists'].map((note,n)=>{
											  		return <div key={`count_note1_${n}`}><div className='editortxtrecap'><strong>{note.notes_title}</strong>&nbsp;&nbsp;&nbsp;<span className="orange_txt1">{note.modified_date}</span><span dangerouslySetInnerHTML={{ __html:note.notes?note.notes:'No Notes available for this Learning room.'}} /></div></div>
													})
												}
												</div>
												:
												<div>No Notes available for this Learning room.</div>
											}
											</div>

										</div>
									</div>
								</div>
		 });
	    }

		let lr_module_name_lists=null;
		if(this.props.lr_module_name_lists!=null || this.props.lr_module_name_lists!=undefined){
			lr_module_name_lists = this.props.lr_module_name_lists.map((key,index)=>{
				return <option key={`option-key${index}`} value={key['module_id']+"#"+key['learningroom_id']}>{key['module_name']}</option>
			});
		}

		let module_name_list=null;
		let module_lr_lists=null;
		   if(this.props.module_name_list!=null || this.props.module_name_list!=undefined){
				module_name_list = this.props.module_name_list.map((mod,list)=>{
					return <div key={`main-key${list}`} className="allcss" id={`Mod1${mod['module_id']}`} style={{display:`${list==0?'':'none'}`}}><h2 className="allcss" id={`Mod${mod['module_id']}`}  style={{display:`${list==0?'':'none'}`}}>{mod['module_name']}({mod['lrnames']})
										</h2><input type='hidden' name={`moduleLrIds${list}`} id={`moduleLrIds${list}`} value={mod['lrids']} />

				  {this.props.module_lr_lists[list].map((key,index)=>{
					return <div key={`lr-key${index}`} className='allcss lrroomcss' id={`ModuleHier${key['lr']}`} style={{display:`${index==0?'':'none'}`}}>

								
												<div className="recap-content" id={`LROOM${key['lr']}`} >
													<div className="recap-left" >
														<ul>
														{this.props.module_lr_lists[list][index].divider.map((divide,divi)=>{
															return <div key={`divider1_${divi}`}>
															{this.props.module_lr_lists[list][index].componentslists[divide].map((val,ind)=>{
																return <li key={`lr-li${ind}`}><div className={val['spanclass']}></div></li>
																	
																	})
																}
																<li className="recapsep">
																	      <div className="lrdivider-rc">&nbsp;</div>
															            </li>
																</div>
															})
													 	 }

														</ul>
													 </div>

															<div className="recap-right">
																<h2>{key['lr_name']}</h2>
																{key['recap']!='' ?
																	<div className="recap-right-content">
																		<h3>Recap</h3><span dangerouslySetInnerHTML={{ __html:key['recap']?key['recap']:''}} />
				                                            		</div>
				                                            		:
				                                            		''
				                                            	}
				                                            	<div className="recap-right-content">
																	<h3>Notes</h3>

																{(key['count_note']!=0)?
																	<div key={`lrcount_note_${index}`}>
					                                            	{key['noteslists'].map((note,n)=>{
																  		return <div key={`lrcount_note1_${n}`}><div className='editortxtrecap'><strong>{note.notes_title}</strong>&nbsp;&nbsp;&nbsp;<span className="orange_txt1">{note.modified_date}</span><span dangerouslySetInnerHTML={{ __html:note.notes?note.notes:'No Notes available for this Learning room.'}} /></div></div>
																		})
																	}
																	</div>
																	:
																	<div>No Notes available for this Learning room.</div>
																}
																</div>
															</div>
														</div>
													</div>

				})
				}
				<div className='allcss' id={`ButtonShow${mod['module_id']}`}  style={{float:'right', paddingRight:'40px',display:`${list==0?'':'none'}`}} >
														<form id='form1' name='form1' method='post' action=''>
														   <input type='hidden' name={`CurrentCount${list}`} id={`CurrentCount${list}`} value='0' />
														   <input type='hidden' name={`txtOverallCount${list}`} id={`txtOverallCount${list}`} value={mod['module_lr_count']} />
														    <input type='hidden' name={`txtCurLearningRoom${list}`} id={`txtCurLearningRoom${list}`} value={mod['lrids']} />
															 <input type='hidden' name={`txtOverallLearningRoom${list}`} id={`txtOverallLearningRoom${list}`} value={mod['lrids']} />
															{(mod['module_lr_count'] > 1 )?
																<div key={`lrmodcount_note_${list}`}><div className='button prevNextBtn' style={{display:'none'}}  id={`PreviousButModule${list}`} ><span>
																 	<input type='button' name={`PreviousBut${list}`} value='Previous' onClick={(e) =>Prevnext.showRecapPreMod(list)} /></span>
																 	</div>
																 	<div className='button prevNextBtn'  id={`NextButModule${list}`} ><span>
																 	<input type='button' name={`NextBut${list}`} value='Next' onClick={(e) =>Prevnext.showRecapNextMod(list)} /></span>
																 	</div>
															 	</div>
															  :
																''
															}
														</form>
													</div>
			</div>
			});
		}

		let dlr_wise_list=null;
		if(this.props.dlr_wise_list!=null || this.props.dlr_wise_list!=undefined){
		 dlr_wise_list = this.props.dlr_wise_list.map((key,index)=>{
			return <div key={`dlr-key${index}`} id={`DLRHire${index}`} style={{display:`${index==0?'':'none'}`}}><br />
							<div className="recap-content" id={`LROOM${key['dlr_id']}`} style={{display:''}}>
								<div className="recap-left" >
									<ul>
									{key['divider'].map((divide,divi)=>{
									 return <div key={`divider2_${divi}`}>

										{key['componentslists'][divide].map((val,ind)=>{
											return <li key={`dlr-li${ind}`}><div className={val['spanclass']}></div></li>
											})
										}
											<li className="recapsep">
											      <div className="lrdivider-rc">&nbsp;</div>
									            </li>
									            </div>
									        })													
										}
									</ul>
								 </div>
										<div className="recap-right">
											<h2>{key['dlr_name']}</h2>
											{key['recap']!='' ?
												<div className="recap-right-content">
													<h3>Recap</h3><span dangerouslySetInnerHTML={{ __html:key['recap']?key['recap']:''}} />
                                        		</div>
                                        		:
                                        		''
                                        	}
                                        	<div className="recap-right-content">
												<h3>Notes</h3>
											{(key['dlr_note_count']!='0')?
												<div key={`dlr_note_count_${index}`}>
                                            	{key['dlr_notes'].map((note,n)=>{
											  		return <div key={`dlr_note_count1_${n}`}><div className='editortxtrecap'><strong>{note.notes_title}</strong>&nbsp;&nbsp;&nbsp;<span className="orange_txt1">{note.modified_date}</span><span dangerouslySetInnerHTML={{ __html:note.notes?note.notes:'No Notes available for this DLR.'}} /></div></div>
													})
												}
												</div>
												:
												<div>No Notes available for this DLR.</div>
											}
											</div>
										</div>
									</div>
								</div>
			});
		}

	let dlr_module_name_lists=null;
	if(this.props.dlr_module_name_lists!=null || this.props.dlr_module_name_lists!=undefined){
		dlr_module_name_lists = this.props.dlr_module_name_lists.map((key,index)=>{
			return <option key={`option-key1${index}`} value={key['module_id']+"#"+key['learningroom_id']}>{key['module_name']}</option>
		});
	}

	let dlr_module_wise=null;
		if(this.props.dlr_module_wise_list!=null || this.props.dlr_module_wise_list!=undefined){
			dlr_module_wise = this.props.dlr_module_wise_list.map((mod,list)=>{
				return <div key={`dmain-key${list}`} className="dlr_allcss" id={`DLRModuleMod1${mod['module_id']}`} 
				style={{display:`${list==0?'':'none'}`}}>
				<h2 className="dlr_allcss" id={`DLRModuleMod${mod['module_id']}`}  
				style={{display:`${list==0?'':'none'}`}}>{mod['module_name']}
									</h2><input type='hidden' name={`moduleLrIds${list}`} id={`moduleLrIds${list}`} value={mod['lrids']} />
												
			  {mod['dlr_module_wise_details'].map((key,index)=>{
				return <div key={`dlr-key${index}`} className='dlr_allcss dlrroomcss' id={`DLRModuleModuleHier${key['dlr_id']}`} style={{display:`${index==0?'':'none'}`}}>
						
							<div className=" recap-content" id={`LROOM${key['dlr_id']}`} >
								<div className="recap-left" >
									<ul>
										{mod['divider'].map((divide,divi)=>{
											return <div key={`dlr_divider_${divi}`}>
											{mod['componentslists'][divide].map((val,ind)=>{
													return <li key={`dlr-li${ind}`}><div className={val['spanclass']}></div></li>
												})
											}
												<li className="recapsep"> 
													  <div className="lrdivider-rc">&nbsp;</div>
												</li>
										</div>
											})
										}
									</ul>
								</div>

							<div className="recap-right">
								<h2>{key['dlr_name']}</h2>
								{key['recap']!='' ?
									<div className="recap-right-content">
										<h3>Recap</h3><span dangerouslySetInnerHTML={{ __html:key['recap']?key['recap']:''}} />
						    		</div>
						    		:
						    		''
						    	}
						    	<div className="recap-right-content">
									<h3>Notes</h3>

								{(mod['dlr_note_count']!=0)?
									<div key={`dlr_note_count2_${index}`}>
						        	{mod['dlr_notes'].map((note,n)=>{
								  		return <div key={`dlr_note_count3_${n}`}><div className='editortxtrecap'><strong>{note.notes_title}</strong>&nbsp;&nbsp;&nbsp;<span className="orange_txt1">{note.modified_date}</span><span dangerouslySetInnerHTML={{ __html:note.notes?note.notes:'No Notes available for this Learning room.'}} /></div></div>
										})
									}
									</div>
									:
									<div>No Notes available for this Learning room.</div>
								}
								</div>

							</div>
						</div>
						</div>

			})
			}
			<div className='dlr_allcss' id={`DLRModuleButtonShow${mod['module_id']}`} style={{float:'right', paddingRight:'40px',display:`${list==0?'':'none'}`}} >
				<form id='form1' name='form1' method='post' action=''>
				   <input type='hidden' name={`DLRModuleCurrentCount${list}`} id={`DLRModuleCurrentCount${list}`} value='0' />
				   <input type='hidden' name={`DLRModuletxtOverallCount${list}`} id={`DLRModuletxtOverallCount${list}`} value={mod['module_dlr_count']} />
				    <input type='hidden' name={`DLRModuletxtCurLearningRoom${list}`} id={`DLRModuletxtCurLearningRoom${list}`} value={mod['dlr_id']} />
					 <input type='hidden' name={`DLRModuletxtOverallLearningRoom${list}`} id={`DLRModuletxtOverallLearningRoom${list}`} value={mod['dlrids']} />

					{(mod['module_dlr_count'] > 1 )?
						<div key={`module_dlr_count${list}`}><div className='button prevNextBtn' style={{display:'none'}}  id={`DLRModulePreviousButModule${list}`} ><span>
						 	<input type='button' name={`DLRModulePreviousBut${list}`} value='Previous' onClick={(e) =>Prevnext.DLRModuleshowRecapPreMod(list)} /></span>
						 	</div>
						 	<div className='button prevNextBtn'  id={`DLRModuleNextButModule${list}`} ><span>
						 	<input type='button' name={`NextBut${list}`} value='Next' onClick={(e) =>Prevnext.DLRModuleshowRecapNextMod(list)} /></span>
						 	</div>
					 	</div>
					  :
						''
					}
				</form>
			</div>
		</div>
		});
		}	
		
		return (
			  <div className="resp-tabs-container hor_1">
				             	<div className="tab-content" id="lr-wise">

				             		{(this.props.lr_count!='0')?
				             			<div>{lr_lists}
				             			<div style={{float:'right'}}>
											<form id="form1" name="form1" method="post" action="">
												<input type="hidden" name="txthidden" id="txthidden" value="0" />
												<input type="hidden" name="txttothid" id="txttothid" value={this.props.lr_count} />
												<div className="button prev-next-btn" style={{display:'none',margin:'0px'}}  id="PreviousBut" >
													<span>
													 <input type="button" name="PreviousBut" value="Previous" title="Previous" onClick={(e) =>Prevnext.showRecapPre()} />
													</span>
												</div>
												<div className="button prev-next-btn" style={{margin:'0px'}} id="NextBut">
													<span><input type="button" name="NextBut" value="Next" title="Next" onClick={(e) =>Prevnext.showRecapNext()}  /></span>
												</div>
											</form>
										</div>
										</div>
				             			:
				             			<div className="timebox_new" style={{display:'block'}}>Please complete at least 1 learning room to view recaps</div>
				             		}
									</div>

									<div className="tab-content" id="lr-module-wise">
											{(this.props.lr_count!='0')?
												<div>
													{module_name_list}
													<div style={{float:'right', paddingRight:'40px'}}><b>Choose a Module</b> &nbsp;
														<select name="lstModuleSelect" style={{width:'200px'}} id="lstModuleSelect" onChange={(e) =>Prevnext.showModule()}>
															<option value="">Select</option>
															{lr_module_name_lists}
															</select>
													</div>
												</div>
											:
												<div className="timebox_new" style={{display:'block'}}>Please complete at least 1 learning room to view recaps</div>
											}


										<input type="hidden" name="TotalModuleValue" id="TotalModuleValue" value="1"  />
									</div>
									<div className="tab-content" id="dlr-wise">
									{(dlr_wise_list!='')?
										<div>
											{dlr_wise_list}
									<div style={{float:'right'}}>
											<form id="form1" name="form1" method="post" action="">
												<input type="hidden" name="DLRtxthidden" id="DLRtxthidden" value="0" />
												<input type="hidden" name="DLRtxttothid" id="DLRtxttothid" value={this.props.dlr_count} />
												<div className="button prev-next-btn" style={{display:'none',margin:'0px'}}  id="DLRPreviousBut" >
													<span>
													 <input type="button" name="DLRPreviousBut" value="Previous" title="Previous" onClick={(e) =>Prevnext.showRecapPreDLR()} />
													</span>
												</div>
												<div className="button prev-next-btn" style={{margin:'0px'}} id="DLRNextBut">
													<span><input type="button" name="DLRNextBut" value="Next" title="Next" onClick={(e) =>Prevnext.showRecapNextDLR()}  /></span>
												</div>
											</form>
										</div>
										</div>
										:
										<div className="timebox_new" style={{display:'block'}}>Please complete at least 1 Dynamic learning room to view recaps.</div>
									}
									</div>

									<div className="tab-content" id="dlr-module-wise">
										{(dlr_module_wise!='')?
										<div>
										{dlr_module_wise}
										<input type="hidden" name="DLRModulehiddenModuleID" id="DLRModulehiddenModuleID" value={this.props.dlr_lear_count['dlr_lear']}/>
										<input type="hidden" name="DLRModuleTotalModuleValue" id="DLRModuleTotalModuleValue" value={this.props.dlr_module_name_lists_count}  />
										<div style={{float:'right', paddingRight:'40px'}}><b>Choose a Module</b> &nbsp;
														
														<select name="DLRModulelstModuleSelect" style={{width:'200px'}} id="DLRModulelstModuleSelect" onChange={(e)=>Prevnext.DLRModuleshowModule()} >
															<option value="">Select</option>
															{dlr_module_name_lists}
															</select>
													</div>
													</div>
													:
													<div className="timebox_new" style={{display:'block'}}>Please complete at least 1 Dynamic learning room to view recaps.</div>
												}
									</div>
				            </div>
		);
	}
}

export default Recap_list;



// WEBPACK FOOTER //
// ./src/learning_records/recap/Recap_list.js